/**
 * From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
 * Returns a random integer between min (inclusive) and max (inclusive)
 * Using Math.round() will give you a non-uniform distribution!
 */
export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function parseNumber(value) {
  if (!value) {
    return value;
  }

  const num = parseInt(value, 10);
  if(isNaN(num)) {
    return value;
  } else {
    return num;
  }
}
